import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Terms from "./pages/Terms";
import PrivacyPolicy from "../src/pages/PrivacyPolicy"
import Faq from "./pages/Faq";
// import DeviceDetector from "./DeviceDetector";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route index element={<Home />} />
          <Route path="faq" element={<Faq />} />
          <Route path="terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />

        {/*<Route path="devicedetector" element={<DeviceDetector />} />*/}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
